// Every human-readable time in reporting takes one shape, in Sydney time,
// whatever the browser's locale or timezone: "2:44pm 22 Sep 2026" for an
// instant, "22 Sep 2026" for a day. Decided 22 September 2026. Months are a
// table rather than Intl's names because newer ICU renders en-AU September as
// "Sept". The host side is vendordashboard/venue_time.py.

const ZONE = "Australia/Sydney";
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const EMPTY = "—";

const PARTS = new Intl.DateTimeFormat("en-US", {
  timeZone: ZONE, hour: "numeric", minute: "2-digit", hour12: true,
  day: "numeric", month: "numeric", year: "numeric",
});

function sydneyParts(value) {
  if (value == null || value === "") return null;
  const instant = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(instant.getTime())) return null;
  const out = {};
  for (const part of PARTS.formatToParts(instant)) out[part.type] = part.value;
  return out;
}

export function sydneyWhen(value) {
  const p = sydneyParts(value);
  if (!p) return EMPTY;
  const suffix = p.dayPeriod.toLowerCase().replace(/\./g, "");
  return `${p.hour}:${p.minute}${suffix} ${p.day} ${MONTHS[Number(p.month) - 1]} ${p.year}`;
}

export function sydneyDay(value) {
  if (value == null || value === "") return EMPTY;
  const iso = typeof value === "string" && /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (iso) return `${Number(iso[3])} ${MONTHS[Number(iso[2]) - 1]} ${Number(iso[1])}`;
  const p = sydneyParts(value);
  if (!p) return EMPTY;
  return `${p.day} ${MONTHS[Number(p.month) - 1]} ${p.year}`;
}
